import React from 'react'
import PropTypes from 'prop-types'
import { ConditionalLink } from '../..'
import classNames from 'classnames'

const SubCategoryItem = ({ link, name, className }) => {
  const classes = classNames('sub-category-item', className)
  return (
    <ConditionalLink className={classes} href={link}>
      {name}
    </ConditionalLink>
  )
}

SubCategoryItem.propTypes = {
  link: PropTypes.string,
  name: PropTypes.string,
  className: PropTypes.string,
}

export default SubCategoryItem
